module.exports = __webpack_public_path__ + "static/media/logo.8533c27d.svg";